import { render, staticRenderFns } from "./addNewClaim.vue?vue&type=template&id=13b076ec&scoped=true&lang=html"
import script from "./addNewClaim.vue?vue&type=script&lang=js"
export * from "./addNewClaim.vue?vue&type=script&lang=js"
import style0 from "./addNewClaim.vue?vue&type=style&index=0&id=13b076ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b076ec",
  null
  
)

export default component.exports